<template>
    <CustomItemsSlider gap="3" id="groupsList" class="flex-1">
        <button v-for="option in sortingOptions || []" :key="option.value" :disabled="selectedItemId == option.value"
            :class="`${(designId == 2 || designId == 3) ? 'py-[0.376rem] md:py-[0.390rem] my-0' : 'py-2 my-1'} flex items-center gap-2 text-[11px] md:text-[12px] lg:text-[13px] select-none cursor-pointer ${isProcessing ? 'opacity-80' : ''} ${selectedItemId == option.value ? 'text-white bg-[#0963ff] active' : designId == 3 ? 'bg-[#E9E9E9] text-[#6A6A6A] hover:brightness-95' :'bg-[#F6F6F6] text-[#ACACAC] hover:brightness-95'} duration-150 !outline-none w-max px-3 md:px-4 text-ellipsis whitespace-nowrap overflow-hidden text-center font-normal rounded-[0.25rem]`.trim()"
            :title="option && option.text" :id="`group-${option.value}`" :aria-label="option && option.text"
            @click="() => onSelect(option.value, option)">
            <img v-if="designId == 2 && !option.hideLogo" class="rounded-full object-cover w-[1.5rem] h-[1.5rem]" @error="onImageError" :src="option.logo" alt :width="24" :height="24" />
            <span> {{ option && option.text }}</span>
        </button>

        <template v-slot:prev>
            <span
                :class="`show-arrow md:opacity-1 active:scale-[0.90] -ms-1 text-[#2955A1] transition-all duration-150 active:border-primary overflow-hidden rounded-full p-1.5 lg:p-2 grid place-content-center`">
                <svg :class="`ltr:rotate-90 rtl:-rotate-90  duration-150  w-3 h-3`" xmlns="http://www.w3.org/2000/svg"
                    width="17" height="11.158" viewBox="0 0 18.78 11.158">
                    <path id="Path_18443" data-name="Path 18443" d="M1869.6,182.149l-7.622,7.622-7.622-7.622"
                        transform="translate(-1852.593 -180.382)" fill="none" stroke="currentColor"
                        stroke-linecap="round" stroke-width="2" />
                </svg>
            </span>
        </template>
        <template v-slot:next>
            <span
                :class="`show-arrow md:opacity-1 active:scale-[0.90] -ms-1 text-[#2955A1] transition-all duration-150 active:border-primary overflow-hidden rounded-full p-1.5 lg:p-2 grid place-content-center`">
                <svg :class="`ltr:-rotate-90 rtl:rotate-90  duration-150  w-3 h-3`" xmlns="http://www.w3.org/2000/svg"
                    width="17" height="11.158" viewBox="0 0 18.78 11.158">
                    <path id="Path_18443" data-name="Path 18443" d="M1869.6,182.149l-7.622,7.622-7.622-7.622"
                        transform="translate(-1852.593 -180.382)" fill="none" stroke="currentColor"
                        stroke-linecap="round" stroke-width="2" />
                </svg>
            </span>
        </template>
    </CustomItemsSlider>
</template>

<script>
import { CustomItemsSlider } from "@/components";
import { onImageError } from "@/helpers";
export default {
    props: {
        selectedItemId: {
            type: [String, Number],
            required: true,
            default: ""
        },
        isProcessing: {
            type: Boolean,
            required: true,
            default: false,
        },
        sortingOptions: {
            type: Array,
            required: true,
            default: () => ([])
        },
        designId: {
            type: Number,
            required: false,
            default: 1,
        },
    },
    components: {
        CustomItemsSlider
    },
    methods: {
        onImageError,
        onSelect( itemId, option ){
            this.$emit("onSelect", {sortBy: itemId, item: option});
        }
    }
}
</script>

<style></style>